import { useEffect, useState } from "react";
import api, { API_BASE } from "@/lib/api";

export default function AdminSubscribers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/subscribers")
      .then(({ data }) => setItems(data.items || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Remove this subscriber?")) return;
    await api.delete(`/admin/subscribers/${id}`);
    load();
  };

  const exportCsv = async () => {
    const res = await fetch(`${API_BASE}/admin/subscribers/export`, { credentials: "include" });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-subscribers" className="space-y-8">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="eyebrow">Audience</div>
          <h1 className="font-serif-display text-3xl md:text-4xl font-700 mt-2">Newsletter Subscribers</h1>
          <p className="text-[var(--rciq-muted)] mt-1">{items.length} total</p>
        </div>
        <button onClick={exportCsv} className="btn-pill btn-pill-primary text-[12px]" data-testid="export-csv">
          Export CSV
        </button>
      </div>

      <div className="bg-white border border-[var(--rciq-line)] rounded-2xl overflow-hidden">
        {loading ? (
          <div className="p-10 text-center text-[var(--rciq-muted)]">Loading…</div>
        ) : items.length === 0 ? (
          <div className="p-16 text-center text-[var(--rciq-muted)]" data-testid="subscribers-empty">
            No subscribers yet. The newsletter signup is live on every insights page.
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-[var(--rciq-bg-tint)] text-[11px] uppercase tracking-[0.1em] text-[var(--rciq-muted)] font-700">
              <tr>
                <th className="text-left p-4">Email</th>
                <th className="text-left p-4 hidden md:table-cell">Name</th>
                <th className="text-left p-4 hidden md:table-cell">Subscribed</th>
                <th className="p-4 w-24"></th>
              </tr>
            </thead>
            <tbody>
              {items.map((s) => (
                <tr key={s.id} className="border-t border-[var(--rciq-line)] hover:bg-[var(--rciq-bg-tint)]/60" data-testid={`subscriber-${s.id}`}>
                  <td className="p-4 font-600">{s.email}</td>
                  <td className="p-4 hidden md:table-cell text-[var(--rciq-muted)]">{s.name || "—"}</td>
                  <td className="p-4 hidden md:table-cell text-[var(--rciq-muted)] text-xs">
                    {new Date(s.subscribed_at).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" })}
                  </td>
                  <td className="p-4 text-right">
                    <button onClick={() => remove(s.id)} className="text-xs font-700 text-red-500 hover:underline">Remove</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
